export { default } from "./useAdminConsoleBreadcrumbsLinks";
